import { CfBannerAdvProps } from "../types";
import BannerAdv from "..";
import React from "react";
import parse from "html-react-parser";

export const convertCfBannerAdvProps = ({
  text,
  children,
}: CfBannerAdvProps) => ({
  text: text?.text ? parse(text.text) : "",
  children,
});

const CfBannerAdv = (props: CfBannerAdvProps) => {
  return <BannerAdv {...convertCfBannerAdvProps(props)} />;
};

export default CfBannerAdv;
